import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "invest-list" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("发布招商项目")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true)
const bindData = reactive({
  statusOptions: [
    {
      value: '',
      label: '全部状态',
    },
    {
      value: '1',
      label: '草稿',
    },
    {
      value: '2',
      label: '待审核',
    },
    {
      value: '3',
      label: '即将开始',
    },
    {
      value: '4',
      label: '报名中',
    },
    {
      value: '5',
      label: '已开始',
    },
    {
      value: '6',
      label: '已结束',
    },
    {
      value: '7',
      label: '已取消',
    }
  ],
  pageParams: {
    curPage: 1,
    pageSize: 10,
    filtrate: {
      status: "",
      keyword: "",
      type: "1",
      projectId: ''
    },
  },
  pageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
  projects: []
});

const handleSizeChangeEvent = (value: any) => {
  bindData.pageParams.pageSize = value;
  bindData.pageParams.curPage = 1;
  searchEvent();
};

const handleCurrentChangeEvent = (value: any) => {
  bindData.pageParams.curPage = value;
  searchEvent();
};


const searchEvent = () => {
  loading.value = true;
  store
    .dispatch("investModule/pageActivityList", bindData.pageParams)
    .then(
      (data) => {
        console.log(data);
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          switch (obj.status) {
            case 1:
              obj.statusName = "草稿";
              break;
            case 2:
              obj.statusName = "待审核";
              break;
            case 3:
              obj.statusName = "报名中";
              break;
            case 4:
              obj.statusName = "已开始";
              break;
            case 5:
              obj.statusName = "已结束";
              break;
            case 6:
              obj.statusName = "已取消";
              break;
            default:
              obj.statusName = "--";
              break;
          }
        }
        bindData.pageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const projectEvent = () => {
  store
    .dispatch("investModule/listProject", bindData.pageParams)
    .then(
      (data) => {
        bindData.projects = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};
projectEvent();
var toInvestDetail = (index: number, row: any) => {
  var id = "add";
  if (row) {
    id = row.id;
  }
  router.push("/middleGround/invest/investList/investDetail/" + id);
}

const deleteEvent = (index: number, row: any) => {
  ElMessageBox.confirm(`您确定要删除 ${row.name} 吗?`)
    .then(() => {
      const params = {
        id: row.id,
      };
      store.dispatch("investModule/deleteActivity", params).then(
        (data) => {
          //成功
          ElMessage.success("删除成功.");
          searchEvent();
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => { },
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};


searchEvent();


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "invest-list-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "invest-list-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).pageParams.filtrate.projectId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).pageParams.filtrate.projectId) = $event)),
                  size: "large",
                  onChange: searchEvent,
                  placeholder: "请选择项目"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).projects, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).pageParams.filtrate.status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).pageParams.filtrate.status) = $event)),
                  size: "large",
                  onChange: searchEvent,
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).statusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).pageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).pageParams.filtrate.keyword) = $event)),
                  modelModifiers: { trim: true },
                  onKeyup: _withKeys(searchEvent, ["enter"]),
                  placeholder: "请输入关键字搜索",
                  size: "large"
                }, null, 8, ["modelValue", "onKeyup"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "invest-list-search-rt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: _unref(toInvestDetail)
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _unref(bindData).pageResult.result,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "招商标题",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "projectName",
          label: "地产项目",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "起止时间",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.startTime) + "~" + _toDisplayString(scope.row.endTime), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "待审核的/通过的",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.applyWillAditNumber) + " / " + _toDisplayString(scope.row.applyAuditPassNumber), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "报名的/计划的",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.applyNumber) + " / " + _toDisplayString(scope.row.joinQuantity), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "状态/更新时间",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.statusName), 1),
            _createElementVNode("div", null, _toDisplayString(scope.row.updateTimeString), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (_unref(toInvestDetail)(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (deleteEvent(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_container, { class: "account-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).pageParams.curPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).pageParams.curPage) = $event)),
          "page-size": _unref(bindData).pageParams.pageSize,
          "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).pageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).pageResult.totalCount,
          "onUpdate:total": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).pageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    })
  ]))
}
}

})